import { isCurrentView } from "../../../shared/utils/view-util";
import { initEmailValidation } from "../../../shared/utils/email-validation-util";

document.addEventListener("DOMContentLoaded", function () {
  if (!isCurrentView(".signup.update_email")) {
    return;
  }

  initEmailValidation();
});
